import { useEffect, useState } from "react";
import { cn } from "../../lib/utils"; // adjust path if your utils is in src/lib/utils.js

export function Meteors({
  className,
  children,
  count = 18,          // slightly fewer for cleaner look
  angle = 215,
  // We override defaults based on theme, but keep props for flexibility
}) {
  const [meteors, setMeteors] = useState([]);

  useEffect(() => {
    setMeteors(
      Array.from({ length: count }, (_, i) => ({
        id: i,
        left: Math.random() * 100,           // random positions look more natural
        delay: Math.random() * 6 + 0.5,
        duration: 5 + Math.random() * 9,    // longer = calmer
      }))
    );
  }, [count]);

  return (
    <div
      className={cn(
        "fixed inset-0 overflow-hidden",
        "bg-white dark:bg-neutral-950",     // ← white in light, near-black in dark
        className
      )}
    >
      {/* Keyframe animation */}
      <style>{`
        @keyframes meteor-fall {
          0% {
            transform: rotate(${angle}deg) translateX(0);
            opacity: 1;
          }
          70% {
            opacity: 1;
          }
          100% {
            transform: rotate(${angle}deg) translateX(-100vmax);
            opacity: 0;
          }
        }
      `}</style>

      {/* Very subtle overlay – barely noticeable in light mode */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background: `
            radial-gradient(ellipse at 50% 0%, rgba(0,0,0,0.03) 0%, transparent 60%),
            radial-gradient(ellipse at 100% 100%, rgba(0,0,0,0.02) 0%, transparent 60%)
          `,
        }}
      />

      {/* Meteors */}
      {meteors.map((meteor) => (
        <span
          key={meteor.id}
          className="absolute h-[1px] w-[1px] rounded-full bg-gray-900 dark:bg-gray-100"
          style={{
            top: "-30px",
            left: `${meteor.left}%`,
            animation: `meteor-fall ${meteor.duration}s linear infinite`,
            animationDelay: `${meteor.delay}s`,
          }}
        >
          {/* Tail */}
          <span
            className="absolute top-1/2 -translate-y-1/2 left-full w-20 h-[1px] bg-gradient-to-r from-gray-900/60 to-transparent dark:from-gray-100/50 dark:to-transparent"
          />
        </span>
      ))}

      {/* Soft vignette – very light in light mode */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at center, transparent 0%, transparent 50%, rgba(0,0,0,0.03) 100%)",
        }}
      />

      {/* Content */}
      {children && <div className="relative z-10 min-h-screen">{children}</div>}
    </div>
  );
}

// Optional demo (you can remove this export if not needed)
export default function MeteorsDemo() {
  return <Meteors count={12} angle={225} />;
}
